export const debounce = (func: Function, delay: number) => {
	let timeoutId: ReturnType<typeof setTimeout> | null = null;
	return (...args: any[]) => {
		if (timeoutId) clearTimeout(timeoutId);
		timeoutId = setTimeout(() => {
			func(...args);
		}, delay);
	};
};
export const transformObjectives = (objectives: any[]) =>
		objectives?.map((item) => ({
			label: item.objective,
			value: item.prompt,
		})) || [];

export const personalizationOptions = [
	{
		value: 1,
		label: 'One to Many',
		tooltip: 'Generates personalized emails based on Segment-level data',
	},
	{
		value: 2,
		label: 'One to Few',
		tooltip: 'Generates personalized emails using Company-level data',
	},
	{
		value: 3,
		label: 'One to One',
		tooltip:
			'Generates hyper-personalized emails using both Company and Contact data.',
	},
];
